import { Typography } from '@navi/web-ui/lib/primitives';
import styles from '../EnachCard.module.scss';
import { ENACHStatus } from './const';
import { AlertIcon } from '@navi/web-ui/lib/icons';

const AutopayNotSetup = () => {
  return (
    <>
      <div className={styles.enachCardErrorIcon}>
        <AlertIcon color={'var(--navi-color-blue-base)'} />
      </div>

      <div className={styles.enachCardFailureReason}>
        <Typography
          variant="p3"
          color={'var(--navi-color-blue-base)'}
          className={styles.enachFailureReasonText}
        >
          {ENACHStatus.AutopayNotSetup}
        </Typography>
      </div>
    </>
  );
};

export default AutopayNotSetup;
